import { callRecordingPresentation, type CallRecordingPresentation } from './CallRecordingState';
import type { BrowserCall } from './types';

export type TicketCallPresentation = {
  title: string;
  number: string;
  contact: string;
  operator: string;
  extension: string;
  directionLabel: 'Входящий' | 'Исходящий';
  statusLabel: string;
  statusTone: 'completed' | 'active' | 'missed' | 'failed' | 'cancelled';
  durationLabel: string;
  recording: CallRecordingPresentation;
};

function callDuration(value?: number) {
  const total = Math.max(0, Math.floor(Number(value) || 0));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
export function ticketCallPresentation(call: BrowserCall): TicketCallPresentation {
  const inbound = call.direction === 'INBOUND';
  const directionLabel = inbound ? 'Входящий' : 'Исходящий';
  const directionTitle = inbound ? 'входящий' : 'исходящий';
  const status = String(call.status || '').toUpperCase();
  const statusPresentation = ({
    COMPLETED: { prefix: 'Завершён', label: 'Завершён', tone: 'completed' },
    ANSWERED: { prefix: 'Идёт', label: 'Разговор', tone: 'active' },
    RINGING: { prefix: '', label: 'Вызов', tone: 'active' },
    INITIATED: { prefix: '', label: 'Создаётся', tone: 'active' },
    MISSED: { prefix: 'Пропущен', label: 'Пропущен', tone: 'missed' },
    FAILED: { prefix: 'Ошибка:', label: 'Ошибка', tone: 'failed' },
    CANCELLED: { prefix: 'Отменён', label: 'Отменён', tone: 'cancelled' },
  } as const)[status as 'COMPLETED' | 'ANSWERED' | 'RINGING' | 'INITIATED' | 'MISSED' | 'FAILED' | 'CANCELLED']
    || { prefix: '', label: status || 'Звонок', tone: 'active' as const };
  const title = statusPresentation.prefix
    ? `${statusPresentation.prefix} ${directionTitle} звонок`
    : `${directionLabel} звонок`;
  const preferredNumber = inbound ? call.from_number : call.to_number;
  const fallbackNumber = inbound ? call.to_number : call.from_number;

  return {
    title,
    number: String(preferredNumber || fallbackNumber || '').trim() || 'Номер не определён',
    contact: String(call.contact_name || '').trim() || 'Контакт не определён',
    operator: String(call.operator_user_name || call.operator_name || '').trim() || 'Оператор не определён',
    extension: String(call.extension || '').trim() ? `доб. ${String(call.extension).trim()}` : 'без добавочного',
    directionLabel,
    statusLabel: statusPresentation.label,
    statusTone: statusPresentation.tone,
    durationLabel: callDuration(call.duration_seconds),
    recording: callRecordingPresentation(call),
  };
}
